// 课程详情页公共API存放，例：课程详情；
import ajax from '@/utils/ajax';

const header = '/web';
const headerTwo = '/ref';
// 产品详情接口
export const reqCourseDetail = (courseId) => ajax(`${header}/v1/product/${courseId}`);
// 提交订单
export const reqSubOrder = (data) => ajax(`${header}/v1/order/commit`, data, 'POST');
// 课表目录
export const reqCatalogs = (catalogId) => ajax(`${header}/v1/course/catalog/detail/${catalogId}`);
// 校验该课程是否购买
export const reqIsBuyProduct = (productId) => ajax(`${header}/v1/user/course/check?productId=${productId}`);
// 根据产品id集合获取产品列表
export const reqProductList = (productIds) => ajax(`${header}/v1/product/product/info?${productIds}`);
// 获取服务器当前时间
export const reqCurrentTime = () => ajax(`${headerTwo}/v1/system/currentTime`);
// 查询分期金额
export const reqHbPayabler = (payAmount) => ajax(`${header}/v1/pay/hb-payable?payAmount=${payAmount}`);
// 批量教师查询
export const reqTeacherList = (teacherList) => ajax(`${header}/v1/teacher/batch?ids=${teacherList}`);
// 买课赠券
export const reqCouponGift = (productId) => ajax(`${header}/v1/gift?productId=${productId}`);

// 书课包班型
export const reqClassType = () => ajax(`${header}/v1/dictionary/type/MINIPROGRAMCLASS`);

// 根据产品id查询班型名称
export const reqClassNameType = (productId) => ajax(`${header}/v1/product/class-type-name?productId=${productId}`);
